export const TEMPLATES = [
  {
    id: "deed-back-request",
    title: "The Deed-Back Request",
    purpose: "Ask your developer directly about their surrender or take-back program — the cheapest legitimate exit most owners never think to request.",
    body: `Subject: Request for Deed-Back / Surrender Program Information

Dear Owner Services,

I am writing regarding my ownership at [RESORT NAME], account number [ACCOUNT NUMBER].

I am considering exiting my ownership and would like to understand whether [DEVELOPER NAME] currently operates a deed-back, surrender, or take-back program for which I may be eligible.

Specifically, I would appreciate written answers to the following:

1. Does a surrender or deed-back program currently exist for my ownership type?
2. What are the eligibility requirements (account standing, loan status, ownership type)?
3. What costs, if any, would I be responsible for?
4. What is the process and expected timeline?
5. If I am not currently eligible, what conditions would make me eligible in future?

I am not behind on any payments and I am not requesting to stop payment. I am simply seeking a clear, written statement of my options.

Please respond in writing to this email/letter within 30 days.

Thank you,
[FULL NAME]
[ADDRESS]
[PHONE] · [EMAIL]`,
  },
  {
    id: "cold-call-response",
    title: "The Cold-Call Response",
    purpose: "A calm, complete reply for when a company contacts you claiming a buyer is waiting. It ends the conversation on your terms — and filters scams instantly.",
    body: `Thank you for reaching out. Before I consider anything further, please provide the following in writing:

1. Your company's full legal name, physical address, and state of incorporation
2. The real estate license number of the broker who would handle my sale, and the state where it is issued
3. The name of the licensed escrow or title company that would hold all funds
4. A written statement of all fees, and confirmation that no payment is required from me before a completed closing
5. The full name and corporate identity of the buyer you say is waiting

Please also confirm that you understand I will verify each of these independently before any further conversation, and that I do not make payments by wire transfer, gift card, or cryptocurrency under any circumstances.

If you are a legitimate brokerage, none of this will be a problem.

[FULL NAME] · [EMAIL]`,
  },
  {
    id: "resale-charge-dispute",
    title: "The Charge Dispute Letter",
    purpose: "For your card issuer when a company took an upfront fee and delivered nothing. Card networks know these operations — a clear, dated letter wins disputes.",
    body: `Subject: Dispute of Charge — [COMPANY NAME] — [AMOUNT] on [DATE]

To whom it may concern,

I am disputing the above charge made to my card ending [LAST 4 DIGITS].

On [DATE], I paid [COMPANY NAME] [AMOUNT] for [SERVICE DESCRIBED — e.g., "timeshare resale marketing services"]. The company represented that [WHAT WAS PROMISED — e.g., "a buyer was already secured for my ownership and a sale would complete within 90 days"].

Since payment:
- [WHAT ACTUALLY HAPPENED — e.g., "no buyer has been presented, no marketing activity has been demonstrated, and the company no longer answers calls or emails"]

I attempted to resolve this directly with the merchant on [DATE(S) OF CONTACT ATTEMPTS], without success.

I have attached: the service agreement, my payment receipt, and records of my contact attempts.

This transaction fits the established pattern of upfront-fee timeshare resale fraud, of which your disputes department will be aware. I am requesting a full chargeback of [AMOUNT].

Thank you,
[FULL NAME]
[CARDHOLDER ADDRESS]
[PHONE] · [EMAIL]`,
  },
];
